// src/mixins/myMixin.js
import CatalogAPI from "../../../../api/catalogue/catalog";
import alertMixin from 'shared/mixins/alertMixin';
import configMixin from 'shared/mixins/configMixin';
import accountMixin from '../../../../mixins/account';
import helperMixin from 'shared/mixins/helperMixin';

export default {
    mixins: [accountMixin, alertMixin, configMixin,helperMixin,],
    methods: {
        async getCatalog(){
            if (!this.currentUser || this.isCatalogFetching) {
                return
            }
            try {
                this.isCatalogFetching = true;
                let catalog = this.catalog;
                if (!this.catalog?.id) {
                    console.log("THS CALL");
                    const {data} = await CatalogAPI.getDefaultCatalog();
                    if (!data) {
                        return;
                    }
                    this.catalog = data;
                    catalog = data;
                }


                // populate messages
               const messages = {};
               if (catalog.messages) {
                //    MESSAGE_ACTIONS_LIST.forEach(action => {
                   this.message_actions.forEach(action => {
                       if (catalog.messages.hasOwnProperty(action.id)) {
                           // Merge existing message with default action
                           // if message exist use that else default
                           const message = catalog.messages[action.id].message || action.defaultMessage;
                           messages[action.id] = {
                               ...action,
                               ...catalog.messages[action.id],
                               message,
                               action: action,
                               isRealMsg: true,
                               isEditOpen: false,
                           };

                       } else {
                           // Use the default action
                           messages[action.id] = {
                               ...action,
                               message: action.defaultMessage,
                               action: action,
                               isRealMsg: false,
                               isEditOpen: false,
                           };
                       }
                   });

                   this.messages = messages;
                }else{
                     // If data.messages is falsy, set this.messages to default values
                    // MESSAGE_ACTIONS_LIST.forEach(action => {
                    this.message_actions.forEach(action => {
                        messages[action.id] = {
                            ...action,
                            message: action.defaultMessage,
                            action: action,
                            isRealMsg: false,
                            isEditOpen: false,
                        };
                    });
                    this.messages = messages;
                }

                //  set initial selected inbox based on catalog
                if (catalog.inbox_id) {
                    this.selectedInbox = this.inboxes.find(el=>el.id === catalog.inbox_id);
                }
                this.isCatalogFetching = false;
            } catch (error) {
                this.isCatalogFetching = false;
                console.log("getCatalog = ",error);
                this.showAlert('error to get catalog');
            }
        },

        handleShopLogoChange(event) {
            const file = event.target.files[0];
            if (!file) return;

            // Check file size (2MB limit)
            const maxSize = 2 * 1024 * 1024; // 2MB in bytes
            if (file.size > maxSize) {
            this.showAlert("File exceeds 2MB limit.");
            return;
            }

            const img = new Image();
            const objectUrl = URL.createObjectURL(file);

            img.onload = () => {
            // Check if the image is square
            // if (img.width !== img.height) {
            //   this.showAlert("Image must be square.");
            //   URL.revokeObjectURL(objectUrl);
            //   return;
            // }

            // Resize the image to 600x600
            const canvas = document.createElement("canvas");
            canvas.width = 600;
            canvas.height = 600;
            const ctx = canvas.getContext("2d");
            ctx.drawImage(img, 0, 0, 600, 600);

            // Set the resized image as preview
            canvas.toBlob((blob) => {
                const resizedObjectUrl = URL.createObjectURL(blob);
                this.newUploadedLogoPreview = resizedObjectUrl;
                this.newUploadedLogoFile = blob;
                URL.revokeObjectURL(objectUrl); // Clean up
            }, "image/jpeg");
            };

            img.onerror = () => {
            this.showAlert("Failed to load image.");
            URL.revokeObjectURL(objectUrl);
            };

            img.src = objectUrl;
        },
        // end methods
    },

  };
